import {
  Button,
  Card,
  Conditional,
  EmptyState,
  Field,
  FieldContext,
  RawInput,
} from '@payaca/ambrosia';

import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

export type TProps = {
  options: {
    id: string;
    label: string;
  }[];
  onAppend: () => void;
  onRemove: (index: number) => void;
};

const ChecklistItemsInput: FC<TProps> = (props) => {
  const { options, onAppend, onRemove } = props;

  const { name: namePrefix } = useContext(FieldContext);

  const { register } = useFormContext();

  return (
    <Card>
      <Card.Body className="flex flex-col gap-2.5">
        {options.map((option, index) => {
          const name = `${namePrefix}.${index}.label`;

          return (
            <Field key={option.id} name={name}>
              <div className="flex items-center gap-2.5">
                <RawInput
                  className="w-full"
                  sizeVariant="sm"
                  {...register(name)}
                />

                <Button
                  onClick={() => onRemove(index)}
                  variant={'white'}
                  size={'sm'}
                >
                  Remove
                </Button>
              </div>
            </Field>
          );
        })}

        <Conditional condition={options.length === 0}>
          <EmptyState
            iconName="check-done-02.3"
            text="No checklist items added"
          />
        </Conditional>

        <Button
          className={clstx(options.length > 0 && 'mt-4')}
          onClick={onAppend}
          variant={'dashed'}
          size={'sm'}
        >
          <UntitledIcon name="plus.3" className="w-4 h-4" />
          Add item
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ChecklistItemsInput;
